module.exports = __webpack_public_path__ + "img/case_huijiao_cloud.3df16123.png";